// extracted by mini-css-extract-plugin
var _1 = "PromotionBannerContainer_clickable__PL7FE";
var _2 = "PromotionBannerContainer_container__L1hLs";
export { _1 as "clickable", _2 as "container" }
